export const teachTrainStoreInfo = state => state.teachTrainStoreInfo
export const getExportParams = state => state.exportParams
